import React from "react";
import { Link } from "react-scroll";
import "./BottomNav.css";

const BottomNav = () => {
  const links = [
    { label: "About", to: "about" },
    { label: "Projects", to: "projects" },
  ];

  return (
    <nav className="bottom-nav">
      <div className="bottom-nav-inner">
        <span className="bottom-nav-label">Explore</span>
        <div className="bottom-nav-links">
          {links.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              smooth={true}
              duration={800}
              offset={-80}
              className="bottom-nav-link"
            >
              {link.label}
            </Link>
          ))}
        </div>
        <Link
          to="contact"
          smooth={true}
          duration={800}
          offset={-80}
          className="bottom-nav-cta"
        >
          Let&apos;s Talk
        </Link>
      </div>
    </nav>
  );
};

export default BottomNav;
